import * as GLOBAL_VARS from 'tools/environments';

const PUBLIC_LOGOUT_URL = process.env.NEXT_PUBLIC_LOGOUT_URL || '';
const PUBLIC_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || '';
const PUBLIC_API_WIDGETS = process.env.NEXT_PUBLIC_API_WIDGETS || '';
const PUBLIC_API_INTERACTION = process.env.NEXT_PUBLIC_API_INTERACTION || '';
const PUBLIC_GOOGLE_MAP_API = process.env.NEXT_PUBLIC_GOOGLE_MAP_API || '';
const PUBLIC_API_ASSETS_URL = process.env.NEXT_PUBLIC_API_ASSETS_URL || '';
const PUBLIC_API_BASE = process.env.NEXT_PUBLIC_API_BASE || '';
const PUBLIC_IMAGE_URL = process.env.NEXT_PUBLIC_IMAGE_URL || '';
const PUBLIC_BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH || '';

const environments = {
	...GLOBAL_VARS,
	PUBLIC_LOGOUT_URL,
	PUBLIC_SITE_URL,
	PUBLIC_API_WIDGETS,
	PUBLIC_API_INTERACTION,
	PUBLIC_GOOGLE_MAP_API,
	PUBLIC_API_ASSETS_URL,
	PUBLIC_IMAGE_URL,
	PUBLIC_API_BASE,
	PUBLIC_BASE_PATH,
};

export default environments;
